import React, { Fragment, Component } from "react";
import { SiteData, RouteData, Head } from "react-static";
import styled, { css, keyframes } from "styled-components";
import "typeface-raleway";
import { Centered } from "../containers/Layout";
import { StickedNavbar } from "../segments/NavbarSegment";
import Footer from "../segments/FooterSegment";
import ReactMarkdown from "react-markdown";

const Site = styled.div`
  @media (max-width: 1810px) {
    font-size: 0.75em;
  }

  @media (max-width: 1337px) {
    font-size: 0.5em;
  }

  min-height: 100vh;
  position: relative;
`;

const Content = styled.div`
  padding: 10em;
`;

class PropsToChildren extends Component {
  render() {
    const { style, className, children, ...filteredProps } = this.props;
    return (
      <div style={style} className={className}>
        {React.Children.map(
          children,
          child =>
            React.isValidElement(child)
              ? React.cloneElement(child, filteredProps)
              : child
        )}
      </div>
    );
  }
}

const Navigation = styled(PropsToChildren)`
  height: 5em;
  width: 100%;
  display: flex;
  background: linear-gradient(30deg, rgb(87, 124, 255), rgb(111, 54, 255));
  padding-left: 5em;
  padding-right: 5em;
  box-sizing: border-box;
  z-index: 1000;
  ${props =>
    props.sticked
      ? css`
          position: fixed;
          top: 0;
        `
      : css`
          position: absolute;
          bottom: 0;
        `};
`;

const NavigationTitle = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 1.5em;
  font-weight: 700;
  color: white;
  padding: 0.5em 1em 0.5em 1em;
  align-self: center;
  justify-self: center;
  white-space: nowrap;

  @media (max-width: 485px) {
    display: none;
  }
`;

const Justify = styled(PropsToChildren)`
  width: 100%;
  height: 100%;
  display: inline-grid;
  grid-auto-flow: column;
  justify-items: center;
  grid-auto-columns: 1fr;
`;

const Link = styled.a`
  all: unset;
  cursor: pointer;
  font-family: "Raleway", sans-serif;
  font-size: 1em;
  font-weight: 700;
  color: rgb(217, 211, 232);
  height: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${props => (props.sticked ? "all" : "none")};
  width: 100%;
  ${props =>
    !props.sticked &&
    css`
      &:not(:first-child):not(:last-child) {
        width: 20em;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
        color: rgb(115, 126, 255);
        pointer-events: none;

        &:after {
          width: 20em;
          height: 20em;
          display: block;
          position: absolute;
          content: "";
          border-radius: 50%;
          background-color: white;
          box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.25);
          top: -25%;
          left: 0%;
          z-index: -1;
          pointer-events: all;
        }
      }

      &:first-child:after {
        left: 0;
      }

      &:last-child:after {
        right: 0;
      }

      &:first-child:after,
      &:last-child:after {
        position: absolute;
        content: "";
        width: 50%;
        pointer-events: all;
        height: 100%;
      }
    `};
`;

const Paragraph = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 1.2em;
  color: #333333;
`;

const Headline = styled.div`
  font-family: "Raleway", sans-serif;
  font-size: 2.5em;
  color: #333333;
  font-weight: normal;
  padding: 0.5em;
`;

const FooterContainer = styled.div`
  width: 100%;
  font-size: 1em;
  font-family: Raleway, sans-serif;
  font-weight: 600;
  padding: 1em;
  color: white;
  box-sizing: border-box;
  background: linear-gradient(
    90deg,
    rgba(63, 0, 255, 0.25),
    rgba(63, 0, 255, 0.5)
  );

  text-align: center;
`;

const AbsoluteFooterContainer = styled(FooterContainer)`
  position: absolute;
  bottom: 0;
`;

const FooterLink = styled.a`
  font-size: 1em;
  font-family: Raleway, sans-serif;
  font-weight: 600;
  color: white;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Delimeter = styled.span`
  padding-left: 1em;
  padding-right: 1em;
`;

export const links = [
  {
    href: "/#praxen",
    children: "Praxen"
  },
  {
    href: "/#leistungen",
    children: "Unsere Leistungen"
  },
  {
    href: "/#team",
    children: "Team"
  },
  {
    href: "/#kontakt",
    children: "Kontakt"
  }
];

export default () => (
  <SiteData
    render={({ title }) => (
      <RouteData
        render={({ cms }) => (
          <Site>
            <Head>
              <title>
                {cms["title"]} - {title}
              </title>
            </Head>
            <StickedNavbar links={links} />
            <Content>
              <Centered style={{ padingBottom: "2.5em" }}>
                <Headline children={cms["title"]} />
              </Centered>
              <Paragraph>
                <ReactMarkdown source={cms["imprint-content"]} />
              </Paragraph>
            </Content>
            <Footer />
          </Site>
        )}
      />
    )}
  />
);



// WEBPACK FOOTER //
// /opt/build/repo/src/pages/Imprint.js